import React from 'react';
import { SellerLevelOneBadge, SellerLevelTwoBadge, TopRatedBadge, NewBadge } from '@fiverr-private/badges';

export const SELLER_BADGES = {
    NEW: () => <NewBadge />,
    LEVEL_ONE: () => <SellerLevelOneBadge />,
    LEVEL_TWO: () => <SellerLevelTwoBadge />,
    LEVEL_TRS: () => <TopRatedBadge />,
};
